import {createRouter, createWebHistory} from 'vue-router';
import Home from "@/views/Home.vue";
import Contact from "@/views/Contact.vue";
import Faq from "@/views/Faq.vue";
import Find from "@/views/Find.vue";
import Booking from "@/views/Booking.vue";
import About from "@/views/About.vue";

const routes = [
    {path: '/', component: Home},
    {path: '/en', component: Home},
    {path: '/contacto', component: Contact},
    {path: '/en/contact', component: Contact},
    {path: '/preguntas-frecuentes', component: Faq},
    {path: '/en/faq', component: Faq},
    {path: '/alquiler-habitacion-leon', component: Find},
    {path: '/en/room-rental-leon', component: Find},
    {path: '/rooms', component: Find},
    {path: '/alquiler-piso-leon', component: Find},
    {path: '/apartamentos', component: Find},
    {path: '/en/apartment-rental-leon', component: Find},
    {path: '/apartments', component: Find},
    {path: '/find', component: Find},
    {path: '/alquiler-habitacion-leon/:reference', component: Booking},
    {path: '/alquiler-piso-leon/:reference', component: Booking},
    {path: '/en/room-rental-leon/:reference', component: Booking},
    {path: '/en/apartment-rental-leon/:reference', component: Booking},
    {path: '/reservar', component: Booking},
    {path: '/reservar/:reference', component: Booking},
    {path: '/en/details', component: Booking},
    {path: '/en/booking', component: Booking},
    {path: '/sobre-nosotros', component: About},
    {path: '/en/about-us', component: About},
    {path: '/:catchAll(.*)', redirect: '/'}
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;